import React from "react";
import { Link } from "react-router-dom";

import courseimage1 from "../../img/courses/1.png";
import courseimage2 from "../../img/courses/2.png";
import courseimage3 from "../../img/courses/3.png";

import courseimage4 from "../../img/courses/4.png";
import courseimage5 from "../../img/courses/5.png";
import courseimage6 from "../../img/courses/6.png";

class ModuleSelectionCards extends React.Component {
  render() {
    return (
      <div>
        <div
          className="container-fluid col-lg-8 col-md-12 col-sm-12 col-xs-12"
          id="paths"
        >
          <div className="card-deck ">
            <div className="card mb-4 box-shadow">
              <div className="card-header d-flex align-items-center justify-content-center ">
                <p
                  className="card-title text-dark text-center"
                  id="module-title"
                >
                  I have no idea what I want to do
                </p>
              </div>
              <div className="card-body d-flex flex-column">
                <img
                  className="card-img-top mx-auto my-auto"
                  src={courseimage1}
                  alt="Card image cap"
                />
                <br />
                <Link to="/Module1" target="_blank">
                  <button
                    type="button"
                    className="mt-auto btn btn-lg btn-block btn-outline-dark"
                  >
                    Start
                  </button>
                </Link>
                <div className="text-right">
                  <small className="text-muted">10 mins</small>
                </div>
              </div>
            </div>

            <div className="card mb-4 box-shadow">
              <div className="card-header d-flex align-items-center justify-content-center">
                <p
                  className="card-title text-dark text-center "
                  id="module-title"
                >
                  I have some ideas and want to focus my thinking
                </p>
              </div>
              <div className="card-body d-flex flex-column">
                <img
                  className="card-img-top mx-auto my-auto"
                  src={courseimage2}
                  alt="Card image cap"
                />
                <br />
                <Link to="/Module2" target="_blank">
                  <button
                    type="button"
                    className="mt-auto btn btn-lg btn-block btn-outline-dark"
                  >
                    Start
                  </button>
                </Link>
                <div className="text-right">
                  <small className="text-muted">10 mins</small>
                </div>
              </div>
            </div>

            <div className="card mb-4 box-shadow">
              <div className="card-header d-flex align-items-center justify-content-center ">
                <p
                  className="card-title text-dark text-center "
                  id="module-title"
                >
                  I have changed my mind and need to rethink my plans
                </p>
              </div>
              <div className="card-body d-flex flex-column">
                <img
                  className="card-img-top mx-auto my-auto"
                  src={courseimage3}
                  alt="Card image cap"
                />
                <br />
                <Link to="/Module3" target="_blank">
                  <button
                    type="button"
                    className="mt-auto btn btn-lg btn-block btn-outline-dark"
                  >
                    Start
                  </button>
                </Link>
                <div className="text-right">
                  <small className="text-muted">10 mins</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />
        <div
          className="container col-lg-8 col-md-12 col-sm-12 col-xs-12"
          id="paths"
        >
          <div className="card-deck">
            <div className="card mb-4 box-shadow">
              <div className="card-header d-flex align-items-center justify-content-center ">
                <p
                  className="card-title text-dark text-center  "
                  id="module-title"
                >
                  I know what I want to do but not sure how to get there
                </p>
              </div>
              <div className="card-body d-flex flex-column">
                <img
                  className="card-img-top mx-auto my-auto"
                  src={courseimage4}
                  alt="Card image cap"
                />
                <br />
                <Link to="/Module4" target="_blank">
                  <button
                    type="button"
                    className="mt-auto btn btn-lg btn-block btn-outline-dark"
                  >
                    Start
                  </button>
                </Link>
                <div className="text-right">
                  <small className="text-muted">10 mins</small>
                </div>
              </div>
            </div>

            <div className="card mb-4 box-shadow">
              <div className="card-header d-flex align-items-center justify-content-center ">
                <p
                  className="card-title text-dark text-center "
                  id="module-title"
                >
                  I am ready to apply for a job or PhD
                </p>
              </div>
              <div className="card-body d-flex flex-column">
                <img
                  className="card-img-top mx-auto my-auto"
                  src={courseimage5}
                  alt="Card image cap"
                />
                <br />
                <Link to="/Module5" target="_blank">
                  <button
                    type="button"
                    className="mt-auto btn btn-lg btn-block btn-outline-dark"
                  >
                    Start
                  </button>
                </Link>
                <div className="text-right">
                  <small className="text-muted">10 mins</small>
                </div>
              </div>
            </div>

            <div className="card mb-4 box-shadow">
              <div className="card-header d-flex align-items-center justify-content-center ">
                <p
                  className="card-title text-dark text-center "
                  id="module-title"
                >
                  I have a job, further study place or will be starting my own
                  business
                </p>
              </div>
              <div className="card-body d-flex flex-column">
                <img
                  className="card-img-top mx-auto my-auto"
                  src={courseimage6}
                  alt="Card image cap"
                />
                <br />
                <Link to="/Module6" target="_blank">
                  <button
                    type="button"
                    className="mt-auto btn btn-lg btn-block btn-outline-dark"
                  >
                    Start
                  </button>
                </Link>

                <div className="text-right">
                  <small className="text-muted">10 mins</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModuleSelectionCards;
